import { Card } from '@mui/material';
import React, { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import NotFoundRecords from 'src/components/NotFoundRecords';
import { loadCFDIIncome } from 'src/store/actions/cfdiActions';
import {
  selectCFDIsIncomeList,
  selectCFDIsIncomeListCount,
  selectCFDISQueryOptions
} from 'src/store/selectors/cfdiSelectors';
import {
  isLoadingSelector,
  successSelector
} from 'src/store/selectors/statusSelector';
import { LOAD_CFDIS_INCOME } from 'src/store/constants/CFDI';
import CFDIIncomeTable from './CFDIIncomeTable';
import useStyles from './styles';

const CFDIIncomeList = () => {
  const { classes } = useStyles();
  const dispatch = useDispatch();
  const cfdis = useSelector(selectCFDIsIncomeList);
  const count = useSelector(selectCFDIsIncomeListCount);
  const { page } = useSelector(selectCFDISQueryOptions);
  const loading = useSelector(isLoadingSelector([LOAD_CFDIS_INCOME.action]));
  const success = useSelector(successSelector([LOAD_CFDIS_INCOME.action]));

  const handleChangePage = useCallback(
    (event, value) => {
      dispatch(loadCFDIIncome({ page: value }));
    },
    [dispatch]
  );

  if (success && !loading && !count) {
    return (
      <Card className={classes.prealoderCard}>
        <NotFoundRecords title="NOT_FOUND_RECORDS_MESSAGE.CFDI_INCOME_TITLE" />
      </Card>
    );
  }

  return (
    <CFDIIncomeTable
      cfdis={cfdis}
      count={count}
      page={page}
      handleChangePage={handleChangePage}
      loading={loading}
    />
  );
};

export default CFDIIncomeList;
